"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../@constants");
var _TabContext = require("./contexts/TabContext");
var _Tabs = _interopRequireDefault(require("./components/Tabs"));
require("../../@assets/sass/components/Account.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef User
 * @type {{
 *     uid: string;
 *     taxDocument: string;
 *     firstName: string;
 *     lastName: string;
 *     email: string;
 *     photo?: string;
 *     phone: string;
 *     phoneArea: string;
 *     phoneCountry: string;
 *     birthdate: string;
 *     addresses: {
 * 			city: string;
 *          complementary: string;
 *          country: string;
 *          district: string;
 *          postalCode: string;
 *          state: string;
 *          street: string;
 *          streetNumber: string;
 *     }[];
 *     signInWith2fa: boolean;
 * }}
 */

/**
 * @typedef Company
 * @type {{
 *     uid: string;
 *     name: string;
 *     fantasyName?: string;
 * }}
 */

/**
 * @typedef License
 * @type {{
 *     type: string;
 *     planId: string;
 *     planDescription: string;
 *     isPlan: boolean;
 *     featureId: string;
 *     featureDescription: string;
 *     isFeature: boolean;
 *     used: number;
 *     amount: number | "unlimited";
 *     expirationDate: Date;
 * }}
 */

/**
 * @typedef AccountPageProps
 * @type {{
 *     app: string;
 *     auth: {
 * 		   company: Company;
 *         user: User;
 *		   licenses: License[];
 *         isAuthenticated: boolean;
 *     };
 * }}
 */

/** @param {AccountPageProps} props */
function Account(props) {
  var app = props.app;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    TabComponent = _useContext.TabComponent,
    tabProps = _useContext.tabProps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account",
    "data-app": app
  }, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], props), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-tabs-content"
  }, /*#__PURE__*/_react["default"].createElement(TabComponent, (0, _extends2["default"])({}, props, tabProps))));
}

/**
 * @param {AccountPageProps} props
 * @returns {JSX.Element}
 */
var AccountPage = function AccountPage(props) {
  var app = props.app;
  var color = _constants.colors[app];
  var theme = (0, _material.createTheme)({
    palette: {
      primary: {
        main: color
      },
      secondary: {
        main: color
      }
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_material.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_TabContext.TabProvider, props, /*#__PURE__*/_react["default"].createElement(Account, props)));
};
AccountPage.propTypes = {
  app: _propTypes["default"].string.isRequired,
  auth: _propTypes["default"].any.isRequired
};
var _default = AccountPage;
exports["default"] = _default;